<style lang="less">
@import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="message">
        <div class="message-title">
            <span style="margin-left:20px">消息通知</span>       
        </div> 
        <div v-if="records.length>0">
            <ul class="message-ul" style="cursor:pointer">
                <li v-for="(item,index) in records" :key="index" @click="chageStatus(item)">
                    <p style="padding-top:20px">
                        <img v-if="item.status==0" src="./images/news2.png" />
                        <img v-if="item.status==1" src="./images/news1.png" />
                        <span class="span1">{{item.messageTitle}}</span>
                        <span class="span2">{{item.createDate}}</span>
                    </p>
                    <p style="color:rgba(128,130,135,1);margin-left:43px;">{{item.messageContent}}</p>
                </li>           
            </ul>          
            <div class="commont-page" style="margin-top:30px">
                <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pages}}页</span>
            </div>
        </div>        
        <div class="empty-box" v-if="records.length<=0&&flag">
            <img src="@/assets/empty.png" class="empty-img" style="margin-top:120px" />
            <p>表单暂无数据哦～</p>
        </div>
    </div>  
</template>

<script>
import { _getByPage } from "@/api/message.js";
import Cookies from "js-cookie";
    export default {
        metaInfo: {
            title: '消息通知|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            },{
                name: 'Description',
                content: ''
            }]
        },
        name:'message',
        data(){
            return{
                total:0,
                pages:1,
                pageNumber:1,
                pageSize:9,
                records:[],
                status:null,
                flag:false
            }
        },
        methods: {
           getByPage(){
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                const data = {
                   pageNumber:this.pageNumber,
                   pageSize:this.pageSize,
                   sort:'a.create_date',
                   order:'desc',
                   registerId:userInfo && userInfo.id?userInfo.id:''
                }
                _getByPage(data).then(res => {
                    if(res.code==200){
                       this.records=res.result.records;
                       this.total=Number(res.result.total); 
                       this.pages=res.result.pages;
                       this.flag=true;
                    }
                });
            },
            changepage(index){
                this.pageNumber = index
                this.getByPage()
            },
            chageStatus(item){
                this.getRequest('/message/updateMessageStatus/'+item.id).then(res=>{
                    if(res.code==200){
                        this.getByPage()
                    }
                })
            }
        },
        mounted() {
            this.getByPage()
        },
    }
</script>
<style scoped lang="less">
.message{
    width:1108px;
    height:985px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
    border-radius:8px;
    margin: 25px;
    .message-title{
        width:1108px;
        height:63px;
        line-height: 63px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:8px 8px 0px 0px;
        font-size:14px;
        color:rgba(51,51,51,1);
    }
    .message-ul{
        height: 828px;
        li{          
            width:1048px;
            min-height:92px;
            border-bottom:1px solid #F4F5F5;
            font-size: 14px;
            margin:0 30px;
            list-style:none;
            p{
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 9px;
                img{
                    width:23px;
                    height: 23px;
                    vertical-align: middle;
                    margin-right: 20px;
                }
                .span1{                  
                    font-weight:600;
                    color:rgba(97,97,97,1);
                    line-height:20px;
                    display: inline-block;
                    width: 700px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .span2{
                    font-weight:400;
                    color:rgba(177,177,177,1);
                    line-height:20px;
                    float: right;
                }
            }
        }
      
    }
}
</style>